/**
 * Upload-progress/success/error toasts are raised globally by the map uploader
 * (map/next/uppy/controller.tsx) and, because react-hot-toast's store is a
 * singleton, they linger and render in whatever <Toaster> is mounted — including
 * the dashboard root one. We stamp their toast id with this prefix so screens
 * that shouldn't surface them (the Sites pages) can filter them out, while every
 * other screen keeps the existing behaviour.
 */
export const UPLOAD_TOAST_ID_PREFIX = 'birdi-upload:';

export const isUploadToastId = (id?: string): boolean =>
  !!id && id.startsWith(UPLOAD_TOAST_ID_PREFIX);
